var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.entity && _vm.module && _vm.canRead(_vm.module))?_c('EntityLink',{attrs:{"entity":_vm.entity,"load-entity":true}}):(_vm.entity && _vm.entity.brezel_name)?_c('span',[_c('i',[_vm._v(_vm._s(_vm.entity.brezel_name))])]):_c('span',[_vm._v("System")])
}
var staticRenderFns = []

export { render, staticRenderFns }